export default __webpack_public_path__ + "static/media/WebScrapper.37be74b6.jpg";